var _jsxFileName = "/repo/packages/webassets/src/components/AccountCard/AccountName/AccountName.tsx",
  _this = this;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { Typography } from '@sm/wds-react';
import { createMemoStyles } from '@wds/utils';
import React from 'react';
var useStyles = createMemoStyles(function (theme) {
  return {
    accountName: _defineProperty({
      maxWidth: '225px'
    }, "@media (min-width: ".concat(theme.breakpoints.sm, "px)"), {
      maxWidth: '300px'
    }),
    truncate: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  };
});
var AccountName = function AccountName(_ref) {
  var username = _ref.username;
  var _useStyles = useStyles(),
    accountName = _useStyles.accountName,
    truncate = _useStyles.truncate;
  return /*#__PURE__*/React.createElement("div", {
    className: accountName,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 23,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    component: "div",
    variant: "bodySm",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "AccountName__Username",
    className: truncate,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("strong", {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 11
    }
  }, username))));
};
export default AccountName;
//# sourceMappingURL=AccountName.js.map